class MobileButtons extends HTMLElement {
  connectedCallback() {
    this.activeClass = this.getAttribute("class-name") || "active";
    this.threshold = parseInt(this.getAttribute("threshold") || "0", 10);
    this.target = this.querySelector("div");
    this._onScroll = this._onScroll.bind(this);
    this._onScroll();
    window.addEventListener("scroll", this._onScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this._onScroll);
  }

  _onScroll() {
    if (!this.target) return;
    const scrolled =
      (window.pageYOffset || document.documentElement.scrollTop || 0) >
      this.threshold;
    this.target.classList.toggle(this.activeClass, scrolled);
  }
}

customElements.define("mobile-buttons", MobileButtons);
